import { useShowMessage } from "../../functions/Common/showMessage";
import useFetch from "../../hooks/useFetch";

export default function useCreateConversation() {
  const [fetchWrapper] = useFetch();
  const showMessage = useShowMessage();

  function createConversation(formData, setLoading, onSuccess) {
    fetchWrapper({
      endpoint_url: "conversation/createConversation",
      setLoading: setLoading,
      set_content_type_header: false,
      body: formData,
      onSuccess: (fetch_output) => {
        if (!("error" in fetch_output)) {
          onSuccess(fetch_output.conversation_id);
        } else {
          showMessage({ message: fetch_output.error });
        }
      },
      onFetchError: () => {
        showMessage({ apiType: "fetch", message: "create conversation" });
      },
      onResponseError: () => {
        showMessage({ apiType: "response", message: "create conversation" });
      },
    });
  }

  return { createConversation };
}
